const initialState = {
  modalDeleteData: {
    emableModel: false,
    message: "",
    enableCancleButton: true,
    enableOkButton: true,
    headerMsg: "",
  },
  searchOptions: {},
  availableExportConnectors: {},
  currentApiData: "",
  searchResults: {},
  selectedExportConnector: {},
  totalItems: 0,
  totalPages: 0,
  currentPage: 1,
  tableLoading: false,
  sidebarLoading: false,
  modalLoading: false,
  showApiModel: false,
  pingData: {}
};

const ExportConnectorReducer = (state = initialState, action) => {
  const { type, payload, data, id } = action;

  switch (type) {
    case "SET_SEARCH_OPTIONS":
      return {
        ...state,
        searchOptions: data,
      };
    case "SET_AVAILABLE_EXPORT_CONNECTORS":
      return {
        ...state,
        availableExportConnectors: data,
      };
    case "SET_SEARCH_RESULTS_EXPORT":
      return {
        ...state,
        searchResults: data.content,
        totalItems: data.totalItems,
        totalPages: data.totalPages,
        currentPage: data.page,
      };

    case "ADD_EXPORT_CONNECTOR":
      return {
        ...state,
        currentApiData: payload,
      };

    case "SET_EXPORT_CONNECTOR_BY_ID":
      return {
        ...state,
        selectedExportConnector: data,
      };

    case "DELETE_EXPORT_CONNECTOR":
      return {
        ...state,
        searchResults: state.searchResults.filter((item) => item.id !== id),
        total: state.total - 1,
      };
    case "OPEN_EXPORT_DELETE":
      return {
        ...state,
        modalDeleteData: action.value,
      };
    case "SET_TABLE_LOADING":
      return {
        ...state,
        tableLoading: payload,
      };

    case "OPEN_MODEL_API":
      return {
        ...state,
        showApiModel: action.value,
      };

    case "SET_MODAL_LOADING":
      return {
        ...state,
        modalLoading: payload,
      };
    case "SET_SIDEBAR_LOADING":
      return {
        ...state,
        sidebarLoading: payload,
      };
    case "PING_FILE_STORAGE":
      return {
        ...state,
        pingData: payload
      }  

    default:
      return state;
  }
};

export default ExportConnectorReducer;
